export const CUSTOM_KANBAN_WRAPPER_ID = 'custom-kanban-page-body';
